module.exports = __webpack_public_path__ + "static/media/banner.f6826b58.gif";